<h1 mat-dialog-title>Alterar produtos</h1>
<mat-divider></mat-divider>
<div mat-dialog-content style="width: 1200px;">
    <div class="row mt-4" *ngIf="!bAutenticado">
        <div class="col-sm">
            <mat-form-field appearance="outline" [floatLabel]="'always'">
                <mat-label>Senha master</mat-label>
                <input type="password" id="input_senha_master" matInput [(ngModel)]="senhaMaster" maxlength="50"
                    (keypress)="($event.charCode==13)?autenticarSenha():null" required>
            </mat-form-field>
        </div>

        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="warn" (click)="fechar()">
                <mat-icon>close</mat-icon> Cancelar
            </button>
        </div>
        <div class="col-auto">
            <button class="mt-4" mat-flat-button color="primary" (click)="autenticarSenha()">
                <mat-icon>check</mat-icon> Autenticar
            </button>
        </div>
    </div>

    <div *ngIf="bAutenticado">
        <div class="row">
            <div class="col-sm">
                <div style="color: gray; font-size: small;">* Atenção para a remoção de produtos que afetam a quantidade
                    requisitada para desconto.</div>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-sm text-right">
                Total do pedido: <strong style="font-size: x-large;">R$
                    {{auxValorTotal.toFixed(2).replace('.',',')}}</strong>
            </div>
        </div>


        <div class="row mt-4">
            <div class="col-sm">
                <table mat-table [dataSource]="produtosSource" class="mat-elevation-z2">

                    <ng-container matColumnDef="Codigo">
                        <th mat-header-cell *matHeaderCellDef> Código </th>
                        <td mat-cell *matCellDef="let element"> {{element.CodigoProduto}} </td>
                    </ng-container>

                    <ng-container matColumnDef="Nome">
                        <th mat-header-cell *matHeaderCellDef> Descrição (Nome) </th>
                        <td mat-cell *matCellDef="let element"> {{element.Nome}}
                            <div *ngIf="element.DescontoGrupoPromocional"
                                style="display: inline-block; font-size: smaller; color: gray;"> -
                                {{element.NomeGrupoPromocional + ' | ' + element.PorcentagemDesconto +
                                '%'}}</div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="Valor">
                        <th mat-header-cell *matHeaderCellDef> Valor Uni. </th>
                        <td mat-cell *matCellDef="let element"> R$ {{(!element.DescontoGrupoPromocional ? element.Valor
                            :
                            (element.ValorRealDesconto + ',' + element.ValorCentavosDesconto))}} </td>
                    </ng-container>

                    <ng-container matColumnDef="SubtrairQuantidade">
                        <th mat-header-cell *matHeaderCellDef> Quantidade Comprada </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-icon class="adc_remover" color="primary" aria-label="Incrementar"
                                (click)="adcRemoverUnidade(element, false)">remove
                            </mat-icon>

                            <div class="quantidade_comprada">{{element.QuantidadeComprada}}</div>

                            <mat-icon class="adc_remover" aria-label="Incrementar" color="primary"
                                (click)="adcRemoverUnidade(element, true)">add</mat-icon>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="RemoverProduto">
                        <th mat-header-cell *matHeaderCellDef> Remover </th>
                        <td mat-cell *matCellDef="let element">
                            <button mat-icon-button matTooltip="Remover" (click)="removerProduto(element)"
                                class="iconbutton" color="primary">
                                <mat-icon aria-label="Remover">close</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    <!-- Row shown when there is no matching data that will be provided to the wrapper table. -->
                    <tr class="mat-row" *matNoDataRow>
                        <td class="mat-cell" colspan="7" style="text-align: center;">Nenhum item adicionado para
                            modificar o estoque
                        </td>
                    </tr>
                </table>

                <mat-paginator [pageSizeOptions]="[50, 100, 200]"></mat-paginator>
            </div>
        </div>

        <div class="row mt-4">
            <div class="col-auto">
                <button mat-flat-button color="warn" (click)="fechar()">
                    <mat-icon>close</mat-icon> Cancelar
                </button>
            </div>

            <div class="col-sm text-right">
                <mat-radio-group [(ngModel)]="bEstornarEstoque" aria-label="Estornar estoque dos produtos removidos?">
                    <mat-radio-button value="true" style=" margin-top: 10px;">Aplicar diferença no estoque
                    </mat-radio-button>
                    <mat-radio-button value="false" style=" margin-top: 10px;">Não alterar o estoque</mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="col-auto">
                <button mat-flat-button color="primary" (click)="salvarAlteracoes()">
                    <mat-icon>check</mat-icon> Confirmar alterações
                </button>
            </div>
        </div>
    </div>

</div>